import { render, staticRenderFns } from "./FollowUpTableData.vue?vue&type=template&id=52a701b0"
import script from "./FollowUpTableData.vue?vue&type=script&lang=ts"
export * from "./FollowUpTableData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52a701b0')) {
      api.createRecord('52a701b0', component.options)
    } else {
      api.reload('52a701b0', component.options)
    }
    module.hot.accept("./FollowUpTableData.vue?vue&type=template&id=52a701b0", function () {
      api.rerender('52a701b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/FollowUpTableData.vue"
export default component.exports